import React, { useState } from 'react';
import SbButton from '../Button';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootStateType } from '../../store';
import { UpdateShipmentStatusPostData } from '../../store/reducers/ShipmentHistory/Type';
import { Typography, useTheme, Modal, Box, TextField } from '@mui/material';
import { cancelShipment } from '@Reducers/ShipmentHistory';
import CloseIcon from '@mui/icons-material/Close';
import { isActionAllowed } from '../../utils/allowedActions';
import { ACTION_NAMES, PERFORM_ACTION } from '@Constants/actionsNames';
interface CancelShipmentProps {
  disabled?: boolean;
}

function CancelShipment({ disabled = false }: CancelShipmentProps) {
  const dispatch = useDispatch<AppDispatch>();
  const theme = useTheme();

  const paramQuery = useParams();
  const shipmentNumber = paramQuery?.id || paramQuery?.sn;
  const _userId = useSelector((state: RootStateType) => state.loginUser.profile?._id) || '';

  const { menuAcccessGroupById: accessGroupById } = useSelector((state: RootStateType) => state.accessGroup);

  const isCancelShipmentAllowed = isActionAllowed(
    accessGroupById?.actions,
    ACTION_NAMES.Single_Shipment_View_OR_Processing.cancel_shipment,
    PERFORM_ACTION.write,
  );

  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  const SbActionButtonStyle = {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.text.dark,
  };

  function handleOpen() {
    if (!isCancelShipmentAllowed) return;
    setOpen(true);
  }

  function handleClose() {
    setMsg('');
    setError('');
    setOpen(false);
  }

  function handleSubmit() {
    if (!shipmentNumber) return;

    if (!msg.trim()) {
      setError('Message is required');
      return;
    }

    const postData: UpdateShipmentStatusPostData = {
      _userId,
      shipmentNumbers: [shipmentNumber],
      location: '-',
      msg,
      status: 'cancelled',
    };

    dispatch(cancelShipment(postData));
    handleClose();
  }

  return (
    <div className={`${disabled || isCancelShipmentAllowed ? 'cursor-not-allowed' : ''}`}>
      <SbButton
        containerClass="py-1 px-3 normal-case rounded-xs"
        variant="contained"
        color="primary"
        size="medium"
        style={SbActionButtonStyle}
        onClick={handleOpen}
        startIcon={<CloseIcon />}
        disabled={disabled || !isCancelShipmentAllowed}
      >
        <Typography className="font-semibold md-text">Cancel Order</Typography>
      </SbButton>

      {/* Cancel Shipment Modal */}
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute' as const,
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" mb={2}>
            Cancel Shipment
          </Typography>
          <TextField
            fullWidth
            label="Enter reason/message"
            value={msg}
            onChange={e => {
              setMsg(e.target.value);
              setError('');
            }}
            error={!!error}
            helperText={error}
            multiline
            minRows={3}
          />
          <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
            <SbButton variant="outlined" color="secondary" onClick={handleClose}>
              Cancel
            </SbButton>
            <SbButton variant="contained" color="primary" onClick={handleSubmit}>
              Submit
            </SbButton>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}

export default CancelShipment;
